export const qualitySection = {
  label: '04 / POLÍTICA DE CALIDAD',
  title: 'Calidad como compromiso permanente',
  description: 'Una política orientada a la satisfacción de nuestra comunidad, la mejora continua y el cumplimiento de nuestros objetivos.',
};

export const qualityItems = [
  {
    title: 'Compromiso con nuestros invitados',
    content:
      'En Capsos Telecomunicaciones, estamos comprometidos en entregar servicios como internet, parabólica y un canal de alta calidad.',
  },
  {
    title: '1. Compromiso con la calidad',
    content:
      'En Capsos Telecomunicaciones, estamos comprometidos en entregar servicios de internet banda ancha, televisión por cable y contenidos audiovisuales pertinentes al contexto y de la más alta calidad a nuestra comunidad. Nos esforzamos por cumplir y superar las expectativas de nuestros asociados, usuarios y televidentes de manera confiable, segura y eficiente. Nuestras redes son 100% estructuradas y diseñadas bajo principios de ingeniería actual, además de contar con materiales y tecnología de última generación.',
  },
  {
    title: '2. Satisfacción de la comunidad',
    content:
      'Nuestros asociados, usuarios y televidentes son nuestra máxima prioridad. Nos comprometemos a entender sus necesidades y expectativas, y a buscar soluciones que cumplan con sus requerimientos. Valoramos las sugerencias y comentarios como un insumo para mejorar continuamente nuestros servicios.',
  },
  {
    title: '3. Mejora continua',
    content:
      'En Capsos Telecomunicaciones nos esforzamos por mejorar constantemente nuestros procesos, tecnologías y servicios, así mismo nos capacitamos para fomentar la innovación y la adopción de nuevas tecnologías para mantenernos a la vanguardia de la industria de las telecomunicaciones, con un enfoque regional, pero con estándares globales.',
  },
  {
    title: '4. Cumplimiento legal y normativo',
    content:
      'Durante 30 años, en Capsos Telecomunicaciones hemos cumplido con la normatividad y regulaciones aplicables a la prestación de nuestros servicios, así en 1994 recibimos nuestra personería jurídica, en el año 2000 nuestra licencia de TV comunitaria para la operación de TV, y actualmente hacemos parte del grupo Cable Mio para la operación de la TV por cable, y estamos habilitados con registro TIC por el Ministerio TIC para la prestación de servicios de telecomunicaciones como Internet Banda Ancha. Nos comprometemos a continuar al día y ajustar nuestras prácticas para cumplir con los requisitos legales en la medida que se vayan presentando cambios.',
  },
  {
    title: '5. Formación y desarrollo del personal',
    content:
      'Reconocemos que nuestro talento humano y colaboradores realizan un aporte invaluable, por ello proporcionamos formación continua, oportunidades de desarrollo para mejorar las habilidades y competencias de nuestros empleados y nos esforzamos en proporcionar un ambiente de trabajo respetuoso, que enaltezca la dignidad humana, con comunicación asertiva y en el que se desarrolla constantemente el trabajo en equipo.',
  },
  {
    title: '6. Gestión de adquisiciones',
    content:
      'Gestionamos y monitoreamos los insumos y materiales para adquirir productos y servicios que cumplan con nuestros estándares de calidad. Establecemos relaciones de cooperación con instituciones, entidades y establecimientos del municipio para maximizar la adquisición de bienes y servicios de la zona y así dinamizar la economía local.',
  },
  {
    title:
      '7. Responsabilidad social y comunicación transparente',
    content:
      'Mantenemos una comunicación abierta y transparente con la comunidad, sus representantes, colaboradores, empleados, instituciones y asociados, así como el compromiso de aportar a la construcción de una sociedad cívica desde el respeto, la promoción de los valores de nuestra cultura y el fortalecimiento de nuestra idiosincrasia santarrosana.',
  },
  {
    title: '8. Revisión y actualización',
    content:
      'La presente política de calidad se revisa periódicamente para asegurar su pertinencia y efectividad. Estamos comprometidos con la mejora continua y ajustaremos esta política según sea necesario para cumplir con nuestros objetivos de calidad.',
  },
];
